import { createSlice } from '@reduxjs/toolkit';
import { isEqual } from 'lodash';
import { DataKey, ErrorKey, FetchingKey, initialState } from './allAPIs';

export const callAPIStoreKey = 'APIData';
export const OfflineKey = 'Offline';

const callAPISlice = createSlice({
    name: callAPIStoreKey,
    initialState: initialState(),
    reducers: {
        callAPI(state, action) {},
        syncCallAPI(state, action) {},
        callStarted(state, action) {
            const { storeKey } = action.payload;
            state[storeKey] = {
                [FetchingKey]: true,
                [DataKey]: null,
                [ErrorKey]: null
            };
        },
        callSuccess(state, action) {
            const { storeKey, data } = action.payload;
            state[storeKey] = {
                [FetchingKey]: false,
                [DataKey]: data,
                [ErrorKey]: null
            };
            if (action?.payload?.data?.offline) {
                let existingState = JSON.parse(JSON.stringify(state[OfflineKey]))?.[DataKey] || [];
                let fArr = existingState.filter((a) => a.queueNo !== action?.payload?.data?.queueNo);
                state[OfflineKey] = {
                    [FetchingKey]: false,
                    [DataKey]: fArr,
                    [ErrorKey]: null
                };
            }
        },
        callFailed(state, action) {
            const { storeKey, error, data } = action.payload;
            state[storeKey] = {
                [FetchingKey]: false,
                [DataKey]: data,
                [ErrorKey]: error
            };
        },
        callError(state, action) {
            const { storeKey, errorCode, header } = action.payload;
            state[storeKey][FetchingKey] = false;
            state.error = {
                errorCode: errorCode,
                header: header
            };
        },
        removeError(state, action) {
            state.error = null;
        },

        /*
         * Useful for removing some data from API calls or to reset it so that
         * Call can be made again
         */
        removeAPIData(state, action) {
            const storeKey = action.payload;
            state[storeKey] = {
                [FetchingKey]: false,
                [DataKey]: null,
                [ErrorKey]: null
            };
        },
        editAPIData(state, action) {
            const { storeKey, payload } = action.payload;
            state[storeKey][DataKey] = payload;
        },
        callOffline(state, action) {
            const data = action.payload;
            data.offline = true;
            const offlineStoreKey = OfflineKey;
            const storeKey = data?.apiObj?.updateOfflineStoreKey; // updateOfflineStoreKey - code for updated list in view after save

            let existingState = JSON.parse(JSON.stringify(state[offlineStoreKey]))?.[DataKey] || [];
            data.queueNo = existingState?.length || 0;

            const filteredData = existingState.filter((da) => da.requestObj.planModuleId !== data.requestObj.planModuleId);

            state[offlineStoreKey] = {
                [FetchingKey]: false,
                [DataKey]: [...filteredData, data],
                [ErrorKey]: null
            };
            /*
             * state[storeKey] = {
             *     [FetchingKey]: false,
             *     [DataKey]: updateOfflineData(data, state, storeKey),
             *     [ErrorKey]: null
             * };
             */
        },
        updateOfflineSuccess(state, action) {
            const data = action.payload;
            const offlineStoreKey = OfflineKey;
            let existingState = JSON.parse(JSON.stringify(state[offlineStoreKey]))?.[DataKey] || [];
            const filteredArr = existingState.filter((todo, i) => i !== data.data);
            state[offlineStoreKey] = {
                [FetchingKey]: false,
                [DataKey]: [...filteredArr],
                [ErrorKey]: null
            };
        },
        removeStoreData(state) {
            state = undefined;
        }
    }
});

const updateOfflineData = (data, state, storeKey) => {
    let existingState = JSON.parse(JSON.stringify(state[storeKey]))?.data || [];
    switch (data.apiObj?.method) {
        case 'POST':
            let arr = typeof existingState === 'object' ? Object.values(existingState) : existingState;
            let s1 = [data.requestObj, ...arr];
            return typeof existingState === 'object' ? { ...s1 } : s1;
        case 'DELETE':
            const filteredArr = existingState.filter((todo) => todo.id !== data.requestObj.id);
            return filteredArr;
        default:
            return existingState;
    }
};

// Extract the action creators object and the reducer
const { actions, reducer: callAPIReducer } = callAPISlice;
// Extract and export each action creator by name
export const {
    callAPI,
    syncCallAPI,
    callStarted,
    callSuccess,
    callFailed,
    callError,
    removeError,
    removeAPIData,
    editAPIData,
    callOffline,
    updateOfflineSuccess,
    removeStoreData
} = actions;
// Export the reducer, either as a default or named export
export default callAPIReducer;
